export const cibIcloud = ["32 32","<path d='M26.682 14.302l0.005-0.036c0-3.875-2.63-7.25-6.38-8.203-3.755-0.953-7.672 0.76-9.521 4.167-2.927-1.531-6.464 0.469-6.651 3.771-2.484 0.906-4.135 3.266-4.135 5.906 0 3.474 2.818 6.292 6.292 6.292h19.745c7.51-0.021 8.115-11.057 0.646-11.896z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-icloud.js
// module id = null
// module chunks = 